
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Image } from '@ta-interaktiv/contentbricks'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`Erika ist nun ein Gusti oder Rindli. Sie frisst täglich bis zu 80 Kilogramm Wiesenfutter,
2 Kilogramm Kraftfutter und etwas Salz. Dazu trinkt sie 50 bis 100 Liter Wasser täglich.
Rund 70 Prozent der Schweizer Landwirtschaftsfläche wird für die Futtermittelproduktion
verwendet, damit sind auch Wiesen und Weiden mit gemeint, auf denen Kühe grasen. Auf der
Fläche, die es braucht, um ein Kilogramm Fleisch zu erzeugen, könnten im selben Zeitraum
200 Kilogramm Tomaten oder 160 Kilogramm Kartoffeln geerntet werden. Oder anders gesagt:
Ein Steak benötigt gleich viel Anbaufläche wie 386 Karotten.`}</p>
    <Image file={[require('images/flaechenverbrauch-01.svg'), require('images/flaechenverbrauch-02.svg')]} title='Landflächenverbrauch' subtitle='pro Kilo Nahrungsmittel' source='Quelle: www.swissveg.ch' mdxType="Image" />
    <p>{`Zurzeit leben rund 1,5 Millionen Rinder in der Schweiz. Wenn Wiederkäuer ihr Futter verdauen
und wenn Kuhmist, der als natürlicher Dünger auf der Weide oder dem Acker ausgebracht wird,
zersetzt wird, entsteht Methan. Das ist ein Treibhausgas. In der Schweiz stammen 11 Prozent
der Treibhausgasemissionen aus der Landwirtschaft, davon 40 Prozent von wiederkäuenden Rindern.`}</p>
    <Image file={require('images/emissionen.svg')} title='Anteil der Rinderzucht' subtitle='an den von Menschen verursachten Emissionen in der Schweiz' source='Quelle: WBF -Eidgenössisches Departement für Wirtschaft, Bildung und Forschung' mdxType="Image" />
    <p>{`Eine Milchkuh produziert pro Jahr 7 Tonnen CO`}<sub>{`2`}</sub>{`-Äquivalent, das entspricht einem Hin- und Rückflug
für einen Passagier der Economyklasse von Zürich nach Melbourne (Australien). Da in der Schweiz über
560’000 Milchkühe leben, verursachen sie jährlich gleich viel CO`}<sub>{`2`}</sub>{` wie 1456 vollbesetzte Boeing 777
der Swiss mit 340 Passagieren auf dem Flug Zürich–Melbourne retour.`}</p>
    <Image file={require('images/kueheundboeings.svg')} source='www.myclimate.org' mdxType="Image" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;